import { checkLogin, LoginResult } from 'JIX/utils/login.js';
import { ref } from 'vue';
import { waitForModalHidden } from 'JIX/utils/modal.js';

export default function useModalAuth() {

    const showModal = ref(false);
    const mountModal = ref(false); // To make sure the modal is mounted after the user is logged in.

    async function handleStartWizard() {
        const res = await checkLogin({ source: 'ai-apply-helper_jobtext' });

        if (res === LoginResult.ABORTED) {
            return;
        }
        await waitForModalHidden();
        showModal.value = !showModal.value;
        mountModal.value = true;
    }

    return { showModal, mountModal, handleStartWizard };
}
